import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

// El mismo lugar del <head> donde el servidor dejó los estilos. Sin esto, lo que Emotion
// agregue al navegar queda al final del head y le gana a reglas que en el servidor perdían: la
// página cambia sola después de hidratar.
const marca = document.querySelector('meta[name="emotion-insertion-point"]');

const cache = createCache({
  key: 'css',
  insertionPoint: marca instanceof HTMLElement ? marca : undefined,
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <CacheProvider value={cache}>
        <HydratedRouter />
      </CacheProvider>
    </StrictMode>,
  );
});
